// extracted by mini-css-extract-plugin
module.exports = {"dashboardMissions":"_1u3bMyt3qf_IQ0VHkZlM5h","favedMissionsCard":"b8R7JSmoPEP3NLuz3p8D-","marTop":"_2H1OzpCTtBEKIpEFIiWhHu","pagination":"_3ZRzEqV7zMG8nqJzvCrJSE"};